import { Menu, MenuButton, MenuList, MenuItem, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { deleteContact } from '../service/deleteContact';
import { BsThreeDotsVertical } from 'react-icons/bs';

export const MenuItems = ({ contactList, userId, setRefresh }) => {
  const { guestName, phoneNumber } = contactList;
  const navigate = useNavigate();

  const handleDelete = async () => {
    await deleteContact(userId, contactList?._id, setRefresh);
  };

  // console.log('contactId', contactList);

  return (
    <Menu>
      <MenuButton
        as={Button}
        bg='transparent'
        _selected={{ bg: 'none', border: 'none' }}
      >
        <BsThreeDotsVertical />
      </MenuButton>
      <MenuList>
        <MenuItem
          onClick={() =>
            navigate(`/invite-guest?name=${guestName}&phone=${phoneNumber}`)
          }
        >
          Invite
        </MenuItem>
        <MenuItem onClick={handleDelete}>Delete contact</MenuItem>
      </MenuList>
    </Menu>
  );
};
